<template>
  <groupish @input="createGroup" :with-users="false" type="group"/>
</template>

<script>
  import { mapActions } from 'vuex';
  import Groupish from '../shared/groupish/Groupish';

  export default {
    components: { Groupish },
    data() {
      return {
        savedAlert: false
      };
    },
    methods: {
      createGroup(group) {
        this.$services.authenticator.post('/groups', {
          id: group.id,
          name: group.name,
          servicePermissions: group.servicePermissions,
          user: group.approvers.length ? group.approvers[0] : null,
          members: group.members
        }).then((res) => {
          this.show('Group created');
          this.reset();
          this.$router.replace(`/groups/${res.data.data.id}`);
        }).catch(this.$defaultHandlerHttp);
      },
      ...mapActions('groups', [
        'reset'
      ]),
      ...mapActions('alert', [
        'show'
      ])
    }
  };
</script>

<style scoped>

</style>
